import { z } from 'zod'

export const contactSchema = z.object({
    id: z.number().optional(),
    firstName: z.string().min(1, 'First name is required'),
    surname: z.string().optional().or(z.literal('')),
    email: z.string().email('Please enter a valid email address').optional().or(z.literal('')),
    phone: z.string().optional().or(z.literal('')),
    phonePrefix: z.string().optional().or(z.literal('')),
    position: z.string().optional().or(z.literal('')),
    team: z.string().optional().or(z.literal('')),
})

export type ContactFormData = z.infer<typeof contactSchema>
